import { render, staticRenderFns } from "./CardTeam.vue?vue&type=template&id=33872b46&"
import script from "./CardTeam.vue?vue&type=script&lang=js&"
export * from "./CardTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports